
    <form>
      <dw-form-control>
        <dw-input-group dwSearch [dwSuffix]="suffix_2" dwSize="small">
          <input dw-input placeholder="請選擇" name="filterValue" [(ngModel)]="filterValue" #filterInput readonly>
        </dw-input-group>
      </dw-form-control>
    </form>
    <ng-template #suffix_2>
      <button dwSize="small" class="clearIcon" dw-button dwType="default" (click)="clear()">
        <i class="anticon anticon-close"></i></button>
      <button dwSize="small" dw-button dwType="primary" dwSearch (click)="openModal()">
        <i class="anticon anticon-search"></i>
      </button>
    </ng-template>
  